import React from 'react'
import { Link } from 'react-router-dom'



const TravalSearch = () => {



    return (     
        <div className="travalGo"> 
            <Link to="/traval" className="toggleTextNameC">旅遊景點</Link>
        </div>       
    )
};


export default TravalSearch


